export default __webpack_public_path__ + "static/media/NO.28NFT-0.11ETHM.6f25ed3c.mp4";